// extracted by mini-css-extract-plugin
module.exports = {"chip":"MessageReactions_chip__eGJRd","mine":"MessageReactions_mine__2qRGs"};